// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2WoaP","label":"Input_label__3Av6N"};